import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="container">
      <h1>Privacy Policy</h1>
      <div>
        <h5 className="pt-3">INTRODUCTION</h5>
        <p className="pt-3">
          1.1. Medius Technologies Pvt Ltd, an Indian company incorporated as
          per the provisions of the Companies Act, 2013 having its registered
          office at Plot No 153, Shere Punjab Colony, Andheri East, Mumbai -
          400093, (“Company”/ “We”/ “Our”/ “Us”) are committed to protecting
          your privacy and grant importance to the confidentiality of your data
          over internet. This privacy policy (“Privacy Policy”) shall apply to
          all persons using or accessing (“Users”, “You” or “Your”) any or all
          products, services, features or content offered on the internet
          website www.payemi.net (“Website”) and/or the mobile application
          Payemi (“App”).
        </p>
        <p className="pt-3">
          1.2. This Privacy Policy is an electronic record in the form of an
          electronic contract formed under the Information Technology Act, 2000
          and the rules made thereunder and the amended provisions pertaining to
          electronic documents/ records in various statutes as amended by the
          Information Technology Act, 2000. This Privacy Policy does not require
          any physical, electronic or digital signature and is a legally binding
          document between the User and Us.
        </p>
      </div>
      <div>
        <h5>GENERAL</h5>
        <p className="">
          2.1. In this Privacy Policy, “Personal Information” means any
          information that relates to a natural person, which, either directly
          or indirectly, in combination with other information available or
          likely to be available with a body corporate, is capable of
          identifying such person. (“Personal Information”). Personal
          Information does not include anonymized information that has been
          appropriately processed to make it non-identifiable in order to
          irreversibly prevent its identification. Further, Information
          Technology Act, 2000 and the rules made thereunder, defines “Sensitive
          Personal Information” of a person to mean Personal Information about
          that person relating to:
        </p>
        <ol>
          <li>passwords;</li>
          <li>
            financial information such as bank accounts, credit and debit card
            details or other payment instrument details;
          </li>
          <li>physical, physiological and mental health condition;</li>
          <li>
            name, age, address, e-mail, phone number, date of birth, sexual
            orientation;
          </li>
          <li>medical records and history;</li>
          <li>biometric information;</li>
          <li>
            information received by body corporate under lawful contract or
            otherwise;
          </li>
          <li>
            visitor details as provided at the time of registration or
            thereafter; and
          </li>
          <li>call data records.</li>
        </ol>
        <p className="pt-3">
          Provided, however, that such information will not be considered as
          sensitive if it is freely available and accessible in the public
          domain or is furnished under the Right to Information Act, 2005, any
          rules made there under or any other law for the time being in force.
          “Personal Information” and “Sensitive Personal Information” shall be
          collectively referred to as “Personal Information”{" "}
        </p>
        <p className="pt-2">
          2.3. By providing us Your Personal Information or by downloading and
          using the App and/or Website site, You expressly give Us consent to
          collect, store, process, use & disclose Your Personal Information in
          accordance with this Privacy Policy. If You do not agree to the terms
          of the Privacy Policy, please do not use or access products, services,
          features, or content provided by the App and/or Website.
        </p>
        <p className="pt-2">
          2.4 We respect the privacy of Our Users and are committed to protect
          it in all respects. The information about the User is collected by Us
          as (i) information supplied by Users; (ii) information automatically
          tracked during User’s navigation on the Website/App; and/ or (iii)
          communicated directly to Us via e-mail or telephone or another
          channel.
        </p>
        <p className="pt-3">
          2.5. The User acknowledges that this Privacy Policy, together with
          terms and conditions, forms Our agreement with the User in relation to
          his/her use of the Website/App. The Company presumes adequate and
          lawful parental consent in case the Personal Information is shared by
          a User under the age of 18 (eighteen) years.
        </p>
        <p className="pt-3">
          2.6. For any service that User may use, We only collect the data that
          is strictly necessary (i) for the delivery of the services, (ii) for
          the performance of a contract for which User is a party, (iii) for
          which User has given consent for such processing of data, or (iv) for
          compliance with a legal obligation to which We are subject.
        </p>
      </div>
      <div>
        <h5>INFORMATION COLLECTED</h5>
        <p>
          3.1 If You visit Our Website/App or service just to browse, read pages
          or download information, We automatically track and collect the
          following categories of information (including but not limited to):
        </p>
        <p>
          3.1.1. IP addresses; <br />
          3.1.2. Domain servers; <br />
          3.1.3. Other information with respect to Users device, operating
          system, interaction of User device with the Website/App and
          applications. <br /> (hereinafter referred to as the “Web Browser
          Information”) This information cannot and does not identify You
          personally. <br />
          3.2. In order to provide services through the Website/App, We may
          require the User to provide Us with the following categories of
          information: <br />
          3.2.1. Contact data (such as name, address, email address, phone
          number and date of birth); and <br /> 3.2.1. About Your location such
          as time zone, postal address and location details) to provide You
          better & prompt customer service; <br /> 3.3.3. If the User
          communicates with Us by, for example, e-mail or letter, any
          information provided in such communication may be collected by Us;
          <br />
          3.3.4. Your photo if you choose to add one to Your profile on
          Website/App; <br />
          3.3.5. Information from Your smartphone as per app store policies. You
          authorize Us to have access to this information and You agree that We
          may collect and use this information in accordance with this Privacy
          Policy; <br />
          3.3.6 Access the file storage for saving the receipt of the purchases;{" "}
          <br /> 3.3.7 Financial data (such as account details, e-wallet
          details, bank account or credit or debit card details or other payment
          instrument details etc.) [or credit score] that User may have provided
          Us. We work with multiple payment processors who store these details
          in encrypted format. All Our payment processors are Payment Card
          Industry Data Security Standard (PCI DSS) compliant; <br />
          3.3.8 Personal information stored with third parties that You choose
          to provide to Us, such as Your social media account information and
          Your social media contacts. By linking Your third-party accounts or
          using third party sign-in services, You authorize Us to have access to
          this information and You agree that We may collect and use this
          information only in accordance with this Privacy Policy. <br /> 3.3
          Biometrics Information- Your biometric identifiers and biometric
          information such as fingerprints, faceprints and voiceprints may be
          collected in order to provide you the locker services. This data will
          be stored in the locker and we do not access such information in our
          servers. You acknowledge and consent that such biometric information
          may be subject to the terms and conditions including privacy policy of
          the vault provider. <br />
          3.4 Copy of Aadhaar information You may provide as proof of identity
          or address for KYC processes. All such information is stored or used
          for processing orders and under no circumstance are any of these
          details made available in the public domain. However, We may use this
          information to share with You additional and/ or upcoming information
          regarding the services of Website/App in accordance with this Privacy
          Policy.
        </p>
      </div>
      <div className="pt-3">
        <h5>Your Rights</h5>
        <p>You have the right in certain circumstances to:</p>
        <ol>
          <li>
            withdraw your consent where you have given your consent to us to use
            your Personal Information for certain purposes. You have the right
            to withdraw this consent at any time by contacting us in writing
            using the contact details set out in the “Contact Us” section. This
            will not affect the lawfulness of any use of your information that
            we make before you withdraw your consent. Further, We will have the
            option to stop providing you services for which the said information
            was sought.
          </li>
          <li>
            access and review the Personal Information You have provided to Us.
            If the review reveals that Personal Information has been recorded
            incorrectly or is incomplete You may contact us via e-mail at the
            details as set out in the “Contact Us” section below to correct any
            such inaccuracies;
          </li>
          <li>
            restrict the processing of your Personal Information if one of the
            following applies to you:
            <ol>
              <li>
                you contest the accuracy of the information that we hold about
                you, while we verify its accuracy;
              </li>

              <li>
                we have used your information unlawfully, but you request us to
                restrict its use instead of erasing it;
              </li>

              <li>
                we no longer need the information for the purpose for which we
                collected it, but you need it to deal with a legal claim; or
              </li>
              <li>
                you have objected to us using your information, while we check
                whether our legitimate grounds override your right to object
              </li>
            </ol>
            <li>
              object to the processing of your Personal Information on the basis
              of our legitimate interests;
            </li>
            <li>
              require us to erase your Personal Information without undue delay
              if one of the following applies, unless it is necessary to use
              your Personal Information to comply with a legal obligation or to
              establish, exercise or defend a legal claim:
            </li>
            <ol>
              <li>
                the information is no longer necessary for the purposes for
                which we collected it;
              </li>
              <li>
                you object to us using your information: for the purposes of
                understanding the visitors to the website and there are no
                overriding legitimate grounds for the processing;
              </li>
              <li>you unsubscribe from our marketing communications;</li>
              <li>we have used your information unlawfully;</li>
              <li>
                the information must be erased for compliance with a legal
                obligation to which we are subject. port your Personal
                Information under certain circumstances;
              </li>
            </ol>
            <li>port your Personal Information under certain circumstances;</li>
          </li>
        </ol>
      </div>
      <div className="pt-3">
        <h5>Retention Of Personal Information</h5>
        <p>
          We understand our legal duty to retain accurate data and only retain
          personal data for as long as we need it for the purpose for which we
          collected such data or as legally mandated. We will retain Personal
          Information will vary depending on the purposes that it was collected
          for, as well as the requirements of any applicable law or regulation.
          We may retain your Personal Information to comply with the law,
          prevent fraud, collect any fees owed, resolve disputes, troubleshoot
          problems, enforce our general terms of use, and take other actions as
          permitted by law and as required to provide the Service. Once the
          purpose is satisfied or the legally mandated period has expired, we
          will securely delete your Personal Information.
        </p>
      </div>
      <div className="pt-3">
        <h5>COOKIES</h5>
        <p>
          A “cookie” is a small piece of information stored by a web server on a
          web browser so it can be later read back from that browser. To improve
          the responsiveness for our users, we may use “cookies”, or similar
          electronic tools to collect information to assign each User a unique,
          random number as a user Identification (user ID) to understand the
          user’s individual interests using the identified computer. Unless You
          voluntarily identify yourself (through registration, for example), We
          will have no way of knowing who You are, even if We assign a cookie to
          Your computer. The only Personal Information a cookie can contain is
          information You supply. A cookie cannot read data off your hard drive.
          Cookies cannot be used to run programs or deliver viruses to Your
          computer. We receive and store certain types of information whenever
          you interact with us via Website/App or service though your
          computer/laptop/netbook or mobile/tablet/pad/handheld device etc.
        </p>
      </div>
      <div className="pt-3">
        <h5>DISCLOSURE AND INFORMATION SHARING</h5>
        <ol>
          <li>
            We may share the Sensitive Personal Information to any third
            party/service provider in the following limited circumstances and
            You here by provide us with your consent for the same :
            <ul>
              <li>
                When it is requested or required by law or by any court or
                governmental agency or authority to disclose, for the purpose of
                verification of identity, or for the prevention, detection,
                investigation including cyber incidents, or for prosecution and
                punishment of offences. These disclosures are made in good faith
                and belief that such disclosure is reasonably necessary for
                enforcing these Terms and Conditions; for complying with the
                applicable laws and regulations.
              </li>
              <li>
                Within its group companies and officers and employees of such
                group companies for the purpose of processing Personal
                Information on its behalf. We also ensure that these recipients
                of such information agree to process such information based on
                our instructions and in compliance with this Privacy Policy and
                any other appropriate confidentiality and security measures.
              </li>
            </ul>
          </li>
          <li>
            We shall take all reasonable steps to ensure that the
            confidentiality of Your information is maintained by imposing strict
            confidentiality standards on all the third parties with whom We part
            this information. In all circumstances, We shall ensure that Your
            Personal Information is protected by strict confidentiality
            agreement. We shall not allow any third parties to retain Your
            Personal Information longer than what is warranted by the nature of
            services rendered.
          </li>
          <li>
            We do not disclose Your Personal Information to any advertisers or
            any third party for their marketing and advertising purposes without
            Your explicit consent.
          </li>
          <li>
            We use Users Personal Information to display relevant promotions and
            marketing offers, based on his/her preferences. To the extent we use
            Your Personal Information to market to You, We will provide You the
            ability/right to opt-out of such uses at any time, directly by
            clicking on the unsubscribe link available on each email received,
            by modifying his account settings, or by contacting Us at the
            following email address: hello@payemi.net
          </li>
        </ol>
      </div>
      <div className="pt-3">
        <h5>LINKS TO THIRD PARTY SITES</h5>
        <ol>
          <li>
            Our Website/App may contain links to third party websites or
            applications. The User agrees and understands that privacy policies
            of these websites are not under Our control and the User understands
            that once he/she leaves Our servers, use of any information provided
            by the User or Your Personal Information shall be governed by the
            privacy policy of the operator of the site used by him/her.
          </li>
          <li>
            When the User accesses another website through a link or a URL
            available on the Website/App, this Privacy Policy does not apply
            anymore. We shall in no way be responsible in any way for Your use
            of such sites.
          </li>
          <li>
            We are not responsible for the content or the privacy polices of
            third party websites
          </li>
        </ol>
      </div>
      <div className="pt-3">
        <h5>SECURITY</h5>
        <ol>
          <li>
            The security of Users Personal Information is important to Us. We
            follow generally accepted industry standards to protect the Personal
            Information submitted to Us, both during transmission and once We
            receive it. All information gathered on Our Website/App is securely
            stored within our controlled database. The database is stored on
            servers secured behind a firewall; access to the servers is
            password-protected and is strictly limited.
          </li>
          <li>
            This Personal Information is immediately deleted once User deletes
            the App or deletes his account exclusively made on the Website,
            except to the extent it is necessary to store the same under
            applicable laws. Further, We have implemented commercially
            reasonable physical, managerial, operational and technical security
            measures to protect the loss, misuse and alteration and to preserve
            the security of the Personally Information in Our care.
          </li>
          <li>
            Although We make best possible efforts to store Personal Information
            in a secure operating environment that is not open to the public,
            User must understand that there is no such thing as complete
            security, and We do not guarantee that there will be no unintended
            disclosures of Personal Information. If We become aware that Users
            Personal Information has been disclosed in a manner not in
            accordance with this Privacy Policy, We will use reasonable efforts
            to notify such User of the nature and extent of such disclosure as
            soon as reasonably possible and as permitted by law.
          </li>
        </ol>
      </div>
      <div className="pt-3">
        <h5>FEEDBACK AND GRIEVANCES</h5>
        <p>
          We reserve the right to modify at any time this Policy Privacy and to
          inform User by any mean.
        </p>
      </div>
      <div className="pt-3">
        <h5>REVIEWING AND UPDATING PERSONAL INFORMATION</h5>
        <p>
          In accordance with the legislations in force, User has the right to
          access, to rectify and to object data concerning himself/herself. User
          can access and change the Personal Information and preferences
          provided when account is created through the account page or by
          contacting Us. We shall ensure that any Personal Information found to
          be inaccurate or deficient shall be corrected or amended as feasible.
        </p>
      </div>
      <div className="pt-3">
        <h5>CONTACT US</h5>
        <p>
          If you have any questions, comments or concerns about Our privacy
          practices or would like to provide a feedback on the services offered
          on Website/App, please contact Our grievance officer, Nitin Purswani
          by e-mail at support@payemi.net Our support centres are operative from
          Monday to Friday between 10am and 6pm (subject to holidays).
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
